/* ============================================================
   storage — sign in.
   ============================================================ */

import React, { useState } from 'react';
import { Icon } from './lib';
import { api } from './api';

export default function Login({ onLogin, note }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr('');
    try {
      const d = await api.login(username.trim(), password);
      onLogin({ token: d.token, username: d.username, role: d.role });
    } catch (ex) {
      setErr(ex.status === 401 ? 'That username and password do not match.' : ex.message);
      setBusy(false);
    }
  };

  return (
    <div className="st-login">
      <form className="panel st-login-box" onSubmit={submit}>
        <div className="st-login-mark"><Icon name="drive" size={26}/></div>
        <h1 className="st-login-title">storage<span className="st-dot">.</span></h1>
        <p className="st-login-sub">Two drives, shared with the people who have an account here.</p>
        {note && <div className="alert alert--info st-alert">{note}</div>}
        <div className="field st-field">
          <label htmlFor="st-user">Username</label>
          <input id="st-user" className="input" autoFocus autoComplete="username" value={username}
                 onChange={(e) => setUsername(e.target.value)}/>
        </div>
        <div className="field st-field">
          <label htmlFor="st-pass">Password</label>
          <input id="st-pass" className="input" type="password" autoComplete="current-password" value={password}
                 onChange={(e) => setPassword(e.target.value)}/>
        </div>
        <button type="submit" className="btn st-login-btn" disabled={busy}>{busy ? 'Checking…' : 'Sign in'}</button>
        {err && <div className="alert alert--err st-alert">{err}</div>}
      </form>
    </div>
  );
}
